import apiClient from '@/services/axios'
import { useMemoize } from '@vueuse/core'

export const getWarehouses = ({ business_id, params }) => {
  return apiClient({
    method: 'get',
    url: '/warehouse/query/list',
    headers: business_id
      ? { 'Business-Id': business_id }
      : {},
    params: { ...params, business_id },
  })
}

export const getHashWarehouseList = useMemoize(async (businessId) => {
  const { data: response } = await getWarehouses({ business_id: businessId, params: { limit: 1000 } })

  return (response?.data?.data || response?.data || []).reduce((acc, warehouse) => {
    const id = warehouse.id || warehouse.warehouse_id
    if (id) acc[id] = warehouse
    // Also map by warehouse_id if different
    if (warehouse.warehouse_id && warehouse.warehouse_id !== id) {
      acc[warehouse.warehouse_id] = warehouse
    }
    return acc
  }, {})
})

export const getWarehouseList = (payload) => {
  const { channel_code, ...params } = payload
  const url = channel_code?.includes('tokopedia') ? '/internal' : ''
  return apiClient({
    method: 'get',
    url: `/warehouse/query/v2${url}/list`,
    params,
  })
}

export const getWarehouseListByWorkspace = (params) => {
  return apiClient({
    method: 'get',
    url: `/warehouse/query/list`,
    params,
  })
}

export const getAllWarehouseList = async (params) => {
  const { data: firstPage } = await getWarehouseList({ ...params, page: 1, size: 100 })
  let allWarehouses = firstPage?.data || []
  const totalPages = firstPage?.total_pages || 1

  if (totalPages > 1) {
    const remainingRequests = []
    for (let p = 2; p <= totalPages; p++) {
      remainingRequests.push(getWarehouseList({ ...params, page: p, size: 100 }))
    }
    const results = await Promise.all(remainingRequests)
    results.forEach(({ data: pageData }) => {
      if (pageData?.data) {
        allWarehouses = allWarehouses.concat(pageData.data)
      }
    })
  }

  return allWarehouses
}

export const getWarehouseInternal = (params) => {
  return apiClient({
    method: 'get',
    url: '/warehouse/query/internal/find',
    params,
  })
}

export const getWarehouseById = (warehouse_id) => {
  return apiClient({
    method: 'get',
    url: `/warehouse/query/find-by-id/${warehouse_id}`,
  })
}

export const crudWarehouseInternal = ({ type, data }) => {
  const method = type === 'save' ? 'post' : 'put'
  return apiClient({
    method,
    url: `/warehouse/cmd/api/warehouse/${type}`,
    data,
  })
}
